import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TextIndentLess"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.5 4.5H9V6H1.5V4.5ZM3.75 9H9V10.5H3.75V9ZM1.5 13.5H9V15H1.5V13.5ZM3.75 18H9V19.5H3.75V18ZM12 3H13.5V21H12V3ZM21.1124 17.625L22.1699 16.59L17.4524 12L22.1699 7.41L21.1124 6.375L15.3299 12L21.1124 17.625Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TextIndentLess.vue"]]);
